'use strict';

const _=require('pulsar-utils/dist-es6/_');let

SocketResponse=class SocketResponse{
constructor(status,body={}){
this.status=status;
this.body=_.exists(body.toJSON)?body.toJSON():body;
}

static succeeded(response){
return response.status==='Ok';
}

static FromError(thrownError){
if(thrownError.name==='StatusCodeError'){
return new SocketResponse('HttpError',{
httpStatus:thrownError.statusCode,
errors:_.has(thrownError,'error.errors')?thrownError.error.errors:void 0});

}

if(thrownError.name==='RequestError'){
return new SocketResponse('ConnectionError',{
code:_.has(thrownError,'error.code')?thrownError.error.code:void 0});

}

throw thrownError;
}

static async attemptWithResponse(asyncMethod,asyncErrorHandler,asyncOnSuccess=async result=>SocketResponse.Ok(result)){
return await SocketResponse.attempt(asyncMethod,asyncErrorHandler,asyncOnSuccess);
}

static async attempt(
asyncMethod,
asyncErrorHandler=async error=>SocketResponse.FromError(error),
asyncOnSuccess=async result=>SocketResponse.Ok()){

let result;
try{
result=await asyncMethod();
}catch(error){
return await asyncErrorHandler(error);
}

return await asyncOnSuccess(result);
}

static isHttpError(response,status){
_.ensureInstanceOf('object',response);
_.ensureInstanceOf('number',status);
return response.status==='HttpError'&&response.body.httpStatus===status;
}

static safeDeserializeDate(date,tag){
return date instanceof Date||date===void 0||date===null?
date:
new Date(date);
}};


module.exports=SocketResponse;
module.exports.Ok=body=>new SocketResponse('Ok',body);
module.exports.Error=status=>new SocketResponse(status);
//# sourceMappingURL=socketResponse.js.map
